export default function getPathLevel(slug: string[] | undefined, levels: number) {
    return '/' + (slug?.slice(0, levels) ?? []).join('/');
}
